import { useState } from "react"

import { Button } from "@/atoms"
import { SettingOutlined } from "@/icons"
import { AgentCoreSettings } from "./components/AgentCoreSettings"
import { CopilotStudioSettings } from "./components/CopilotStudioSettings"

import type { CloudConnectionSettingsProps } from "./CloudConnectionSettings.types"

const SETTINGS_KEY = "deployments.cloudConnection.settings"

// The settings of a cloud connection, from its row in the deployments list:
// the platform's connections are read once they are opened
export const CloudConnectionSettings = (
  props: CloudConnectionSettingsProps
) => {
  const { platform, connectionId, t } = props
  const [open, setOpen] = useState(false)
  const PlatformSettings =
    platform === "agentcore" ? AgentCoreSettings : CopilotStudioSettings

  return (
    <>
      <Button
        type="text"
        aria-label={t(SETTINGS_KEY)}
        icon={<SettingOutlined />}
        onClick={() => setOpen(true)}
      />
      {open && (
        <PlatformSettings
          connectionId={connectionId}
          onClose={() => setOpen(false)}
        />
      )}
    </>
  )
}
